import { render, staticRenderFns } from "./RedPacketPopup.vue?vue&type=template&id=0bf2b752&scoped=true&"
import script from "./RedPacketPopup.vue?vue&type=script&lang=js&"
export * from "./RedPacketPopup.vue?vue&type=script&lang=js&"
import style0 from "./RedPacketPopup.vue?vue&type=style&index=0&id=0bf2b752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf2b752",
  null
  
)

export default component.exports